<template>
  <div class="hero" :title="hero.name">
    <img :src="hero.image" :alt="hero.name" class="hero__img" />
  </div>
</template>

<script>
export default {
  name: "Hero",
  props: {
    hero: Object
  }
};
</script>

<style lang="scss">
.hero {
  border: 2px solid #414a65;
  width: 56px;
  height: 34px;

  &__img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
